import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { openSidebar, showPortalPage } from 'js/components/main/MyAccountSidebar/store/actions';

export const useSidebar = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const removeQueryParams = useRemoveQueryParams();
    const sidebarPageURL = useMemo(() => new URLSearchParams(search).get('sidebarPageURL'), [search]);

    useEffect(() => {
        if (sidebarPageURL) {
            dispatch(openSidebar());
            dispatch(showPortalPage({ pageURL: sidebarPageURL, isBackArrowHidden: false }));

            removeQueryParams(['sidebarPageURL']);
        }
    }, [dispatch, sidebarPageURL, removeQueryParams]);
};
